document.addEventListener('DOMContentLoaded', function () {


    let prev = document.querySelector(".accordion");
    prev.querySelector('summary[aria-expanded=\'false\']').setAttribute('aria-expanded','true')
    prev.querySelector('details').setAttribute('open','')

    document.querySelectorAll('.accordion').forEach(accordion =>
        accordion.addEventListener("click",(e) => checkOpenOrclose(e.currentTarget))
    )


    function checkOpenOrclose(eventTarget) {
        if(prev!==eventTarget){
            if(prev){
                updateElements(prev)
            }
            prev = eventTarget
        }
        else {
            prev=null;
        }
    }

    function updateElements(element){
        element.querySelector('summary[aria-expanded=\'true\']').setAttribute('aria-expanded','false')
        element.querySelector('details').removeAttribute('open')
    }
})